const OrderTypes={

    GET_TOTAL_ORDERS:"GET_TOTAL_ORDERS",
    GET_TOTAL_ORDERS_SUCCESS:"GET_TOTAL_ORDERS_SUCCESS"

};

export {OrderTypes};